var map = {
	"./Hummus.jpg": 4995,
	"./beverages/Orange Juice.jpg": 4112,
	"./beverages/Soda.jpg": 385,
	"./beverages/Water.jpg": 1442,
	"./beverages/Yogurt Drink.jpg": 6001,
	"./desserts/Armenian Rice Pudding.jpg": 7225,
	"./desserts/Traditional Baklava.jpg": 8083,
	"./dinners/Beef Kebab.jpg": 5169,
	"./dinners/Beef Shawerma.jpg": 2090,
	"./dinners/Chicken Kebab.jpg": 6698,
	"./dinners/Chicken Shawerma.jpg": 1525,
	"./dinners/Falafel Plate.jpg": 9843,
	"./dinners/Lule Kebab.jpg": 8903,
	"./dinners/Noor Trio.jpg": 7870,
	"./dinners/Protein Bowl.jpg": 7989,
	"./dinners/Veggie Lovers Plate.jpg": 6054,
	"./salads/Fattoush Salad.jpg": 5344,
	"./salads/Garden Salad.jpg": 9503,
	"./salads/Greek Salad.jpg": 2583,
	"./salads/Tabbouli.jpg": 2580,
	"./sides/Baba Dip.jpg": 5695,
	"./sides/Falafel Balls.jpg": 1461,
	"./sides/French Fries.jpg": 233,
	"./sides/Hummus.jpg": 8019,
	"./sides/Kibbee Balls.jpg": 9603,
	"./sides/Sarma.jpg": 104,
	"./sides/Side of Rice.jpg": 1724,
	"./wraps/Beef Kebab Wrap.jpg": 799,
	"./wraps/Beef Shawerma Wrap.jpg": 7910,
	"./wraps/Chicken Kebab Wrap.jpg": 1688,
	"./wraps/Chicken Shawerma Wrap.jpg": 7543,
	"./wraps/Falafel Wrap.jpg": 6070,
	"./wraps/Lule Kebab Wrap.jpg": 7743,
	"./wraps/Noor Works.jpg": 7757,
	"./wraps/Veggie Lovers Wrap.jpg": 4212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8031;